import { render, staticRenderFns } from "./currentOrder.vue?vue&type=template&id=65155398&scoped=true&"
import script from "./currentOrder.vue?vue&type=script&lang=js&"
export * from "./currentOrder.vue?vue&type=script&lang=js&"
import style0 from "./currentOrder.vue?vue&type=style&index=0&id=65155398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65155398",
  null
  
)

export default component.exports